import MuiAppBar, { AppBarProps } from "@mui/material/AppBar";
import SideMenu from "../../components/side-menu";
import { Outlet } from "react-router-dom";
import Toolbar from "@mui/material/Toolbar";
import { Typography, Box, Avatar } from "@mui/material";
import TagRole from "../../components/tag-role";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import { useContext, useState } from "react";
import { UserContext } from "../../context";
import logo from "../../assets/images/logo_new.png";

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({}) => ({}));

const Dashboard = () => {
  const userWorker = useContext(UserContext);
  const [open, setOpen] = useState(true);
  return (
    <div>
      <AppBar
        position="fixed"
        variant="outlined"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar
          sx={{
            pr: "24px", // keep right padding when drawer closed
          }}
        >
          <img src={logo} alt="" width="50px" />
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            sx={{ flexGrow: 1 }}
          >
            Admin Dashboard
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "8px",
            }}
          >
            <Avatar
              alt="Logo"
              src={userWorker.user?.photo}
              sx={{ width: 56, height: 56 }}
            />

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              {userWorker.user?.name}
              <TagRole label={userWorker.user?.role || ""}></TagRole>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <div className="flex row">
        <SideMenu userRole={"master"} />
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;
